import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetCompOffLeaveList } from "../../Repository/Api";
import { errorMsg } from "../Toastify";
import MUIDataTable from "mui-datatables";
import { DateRangePicker } from "react-date-range";
import { enUS } from 'date-fns/locale';
const HodCompoffLeaverequest = () => {
  const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [leaveList, setLeaveList] = useState([]);
  const [dummyleaveList, setDummyLeaveList] = useState([]);
  const [searchText, setSearchText] = useState('')
  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase()))
  )
  // console.log(leaveList)
  const [dateFilterOpen, setDateFilterOpen] = useState(false)
  const filterIntialState = [
    {
      startDate: null,
      endDate: new Date('2030-01-01'),
      key: "selection",
    },
  ]
  const dfm = (date) => {
    return moment(date).format("DD/MM/yyyy")
  }
  const [range, setRange] = useState(filterIntialState);
  // console.log(range[0].startDate, "date range")
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const dateFilterRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
      setDateFilterOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchText) {
      setLeaveList(SearchfilteredData)
    }
    else {
      setLeaveList(dummyleaveList)
    }
  }, [searchText, dummyleaveList]);


  useEffect(() => {
    getLeaveList();
  }, [range]);

  const [active, setActive] = useState(0);
  const links = ["Pending", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getLeaveList = async () => {
    const response = await GetCompOffLeaveList(token);
    if (response && response.statusCode === 200) {
      setDummyLeaveList(response?.data?.comp_off_details.filter(item => {
        const startDate = new Date(item.date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return (startDate >= rangeStartDate && startDate <= rangeEndDate);
      }))
    } else {
      errorMsg(response.message);
    }
  };

  const pendingLeaveLength = leaveList.filter(
    (item) => item.hod_status === "pending"
  ).length;
  const approveLeaveLength = leaveList.filter(
    (item) => item.hod_status === "approved"
  ).length;
  const rejectLeaveLength = leaveList.filter(
    (item) => item.hod_status === "rejected"
  ).length;

  const pendingLeave = leaveList?.filter((leaveList) => leaveList.hod_status === "pending")
  const approvedLeave = leaveList?.filter((leaveList) => leaveList.hod_status === "approved")
  const rejectedLeave = leaveList?.filter((leaveList) => leaveList.hod_status === "rejected")

  let compoffLeave

  if (active === 0) {
    compoffLeave = pendingLeave
  } else if (active === 1) {
    compoffLeave = approvedLeave
  } else if (active === 2) {
    compoffLeave = rejectedLeave
  }


  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
  };

  const columns = [
    {
      name: "first_name",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const lastName = tableMeta.rowData[1];
          return `${value} ${lastName}`;
        },
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "designation",
      label: "Designation",
    },
    {
      name: "date",
      label: "Worked Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "expiry_date",
      label: "Expired Date",
      options: {
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD MMM YY");
        },
      },
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Hod/HodSpecificComprequestview/${value}`}
            >
              View Details
            </Link>
          );
        },
        filter: false,
        download: false
      },
    },
  ];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3 p-0">
                    <h6 className="labeltitle">Comp Off Leave Request</h6>
                  </div>
                  <div className="col-lg-4 p-0">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => { showSelected(index); setRange(filterIntialState) }}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center justify-content-end">
                  <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                    <input
                      className="form-control"
                      defaultValue={range[0].startDate ? ((range[0].startDate.getTime() == range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                    />
                    <span
                      className="material-symbols-outlined leave-filter-calendar"
                      onClick={() => setDateFilterOpen(true)}
                    >
                      calendar_month
                    </span>
                    {dateFilterOpen && (
                      <DateRangePicker
                        ranges={range}
                        onChange={handleSelect}
                        locale={enUS}
                      />
                    )}
                  </div>
                  {range[0].startDate &&
                    <div>
                      <span
                        class="material-symbols-outlined ms-3 filter-reset-button"
                        onClick={() => setRange(filterIntialState)}
                      >
                        cancel
                      </span>
                    </div>}
                </div>
                < MUIDataTable
                  data={compoffLeave}
                  columns={columns}
                  options={options}
                  className="mt-3"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HodCompoffLeaverequest;
